module.exports = __webpack_public_path__ + "files/5961c00070a6982d336c4de883fa4893.png";